export { IGeoForMobileSiteSchema as IOfferGeo } from 'shared/repositories/search-engine/entities/geo/GeoForMobileSiteSchema';
export { IAddressDetailSchema as IAddressDetail } from 'shared/repositories/search-engine/entities/geo/AddressDetailSchema';

export interface IGeo {
  regionId: number;
  address: string;
  undergrounds: IUnderground[];
  highways: IHighways[];
  railways?: IRailways[] | null;
  coordinates?: ICoordinates;
  timezone?: number | null;
  title?: IGeoTitle | null;
  offerType?: string;
}

export interface IUnderground {
  id: number;
  name: string;
  underConstruction: boolean;
  lineColor?: string | null;
  time?: string | null;
  transportType?: ETransportType | null;
}

export interface IHighways {
  id: number;
  name: string;
  distance?: string | null;
}
export interface IRailways {
  id: number;
  name: string;
  time?: string | null;
  travelType?: ETravelType | null;
  directionIds: number[];
  distance: number;
}

export interface ICoordinates {
  lat: number;
  lng: number;
}

export enum ETransportType {
  Transport = 'transport',
  Walk = 'walk',
}
export enum ETravelType {
  /** На транспорте **/
  ByCar = 'byCar',
  /** Пешком **/
  ByFoot = 'byFoot',
}
export interface IGeoTitle {
  name?: string | null;
  link?: string | null;
}
